import type { TicketElement } from '../TicketElement'

export class If implements TicketElement {
  condition: boolean
  trueComponent: TicketElement
  falseComponent?: TicketElement

  constructor(condition: unknown, trueComponent: TicketElement, falseComponent?: TicketElement) {
    this.condition = !!condition
    this.trueComponent = trueComponent
    this.falseComponent = falseComponent
  }

  height(ctx: CanvasRenderingContext2D, width: number) {
    if (this.condition) {
      return this.trueComponent.height(ctx, width)
    } else if (this.falseComponent) {
      return this.falseComponent.height(ctx, width)
    }
    return 0
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number) {
    if (this.condition) {
      this.trueComponent.render(top, ctx, width)
    } else if (this.falseComponent) {
      this.falseComponent.render(top, ctx, width)
    }
  }
}
